import { render } from 'mustache';
import { Renderer } from './renderer';
import { Message } from './message';
import { Statement } from '../model/statement';


@Renderer.register("statement")
export class StatementRenderer extends Renderer {
    render(element: Statement, context: object): Message {
        let content = element.selectContent();
        content = render(content, context);

        return new Message("bubble", {
            content: content
        });
    }
}
